import { Component, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormControl as FormControl, UntypedFormGroup as FormGroup } from '@angular/forms';
import { Subscription } from 'rxjs';
import { TranslationService } from '@sdbn/common';
import { FilterAdministrationContext } from '../../../../filter-administration.context';
import { FilterCondition } from '../../../../filter-administration.model';
import { FilterDetailsComponent } from '../../../../filter-details-component.model';

@Component({
  selector: 'app-transport-status-editor',
  templateUrl: './transport-status-editor.component.html',
  styleUrls: ['./transport-status-editor.component.scss']
})
export class TransportStatusEditorComponent implements OnInit, OnDestroy, FilterDetailsComponent {

  condition: FilterCondition;

  filterAdministrationContext: FilterAdministrationContext;
  filterAdministrationContextSubscription: Subscription;

  detailsFormGroup = new FormGroup({});

  constructor(
    public translationService: TranslationService
  ) {

    this.detailsFormGroup.addControl('transportStatusAny', new FormControl('', []));
    this.detailsFormGroup.addControl('transportStatusPlanned', new FormControl('', []));
    this.detailsFormGroup.addControl('transportStatusRegistered', new FormControl('', []));
    this.detailsFormGroup.addControl('transportStatusWaiting', new FormControl('', []));
    this.detailsFormGroup.addControl('transportStatusRetrieved', new FormControl('', []));
    this.detailsFormGroup.addControl('transportStatusCompleted', new FormControl('', []));
    this.detailsFormGroup.addControl('transportStatusFinished', new FormControl('', []));
    this.detailsFormGroup.addControl('transportStatusCanceled', new FormControl('', []));
    this.detailsFormGroup.addControl('transportStatusPaused', new FormControl('', []));

    this.detailsFormGroup.valueChanges.subscribe(
      value => {
        if (this.detailsFormGroup.dirty) {
          this.condition.data.transportStatusAny = this.detailsFormGroup.controls.transportStatusAny.value === true;
          this.condition.data.transportStatusPlanned = this.detailsFormGroup.controls.transportStatusPlanned.value === true;
          this.condition.data.transportStatusRegistered = this.detailsFormGroup.controls.transportStatusRegistered.value === true;
          this.condition.data.transportStatusWaiting = this.detailsFormGroup.controls.transportStatusWaiting.value === true;
          this.condition.data.transportStatusRetrieved = this.detailsFormGroup.controls.transportStatusRetrieved.value === true;
          this.condition.data.transportStatusCompleted = this.detailsFormGroup.controls.transportStatusCompleted.value === true;
          this.condition.data.transportStatusFinished = this.detailsFormGroup.controls.transportStatusFinished.value === true;
          this.condition.data.transportStatusCanceled = this.detailsFormGroup.controls.transportStatusCanceled.value === true;
          this.condition.data.transportStatusPaused = this.detailsFormGroup.controls.transportStatusPaused.value === true;
          this.filterAdministrationContext.getFilter().dirty = true;
          this.updateEnablement();
        }
      }
    );

  }

  ngOnInit(): void {
  }

  ngOnDestroy() {
    if (this.filterAdministrationContextSubscription != null) {
      this.filterAdministrationContextSubscription.unsubscribe();
    }
  }

  setFilterAdministrationContext(filterAdministrationContext: FilterAdministrationContext) {
    this.filterAdministrationContext = filterAdministrationContext;
    this.condition = this.filterAdministrationContext.getSelectedFilterCondition();
    this.resetForm();
    this.filterAdministrationContextSubscription = this.filterAdministrationContext.contextChange$.subscribe(
      change => {
        try {
          if (change.key === 'selected-filter-condition-changed') {
            this.condition = this.filterAdministrationContext.getSelectedFilterCondition();
            this.resetForm();
          }
        } catch (error) {
          console.log(error);
        }
      }
    );
  }

  private resetForm() {
    this.detailsFormGroup.reset(this.condition.data);
    this.updateEnablement();
  }

  private updateEnablement() {
    if (this.condition.data.transportStatusAny === true) {
      this.detailsFormGroup.controls.transportStatusPlanned.disable({ emitEvent: false, onlySelf: false });
      this.detailsFormGroup.controls.transportStatusRegistered.disable({ emitEvent: false, onlySelf: false });
      this.detailsFormGroup.controls.transportStatusWaiting.disable({ emitEvent: false, onlySelf: false });
      this.detailsFormGroup.controls.transportStatusRetrieved.disable({ emitEvent: false, onlySelf: false });
      this.detailsFormGroup.controls.transportStatusCompleted.disable({ emitEvent: false, onlySelf: false });
      this.detailsFormGroup.controls.transportStatusFinished.disable({ emitEvent: false, onlySelf: false });
      this.detailsFormGroup.controls.transportStatusCanceled.disable({ emitEvent: false, onlySelf: false });
      this.detailsFormGroup.controls.transportStatusPaused.disable({ emitEvent: false, onlySelf: false });
    } else {
      this.detailsFormGroup.controls.transportStatusPlanned.enable({ emitEvent: false, onlySelf: false });
      this.detailsFormGroup.controls.transportStatusRegistered.enable({ emitEvent: false, onlySelf: false });
      this.detailsFormGroup.controls.transportStatusWaiting.enable({ emitEvent: false, onlySelf: false });
      this.detailsFormGroup.controls.transportStatusRetrieved.enable({ emitEvent: false, onlySelf: false });
      this.detailsFormGroup.controls.transportStatusCompleted.enable({ emitEvent: false, onlySelf: false });
      this.detailsFormGroup.controls.transportStatusFinished.enable({ emitEvent: false, onlySelf: false });
      this.detailsFormGroup.controls.transportStatusCanceled.enable({ emitEvent: false, onlySelf: false });
      this.detailsFormGroup.controls.transportStatusPaused.enable({ emitEvent: false, onlySelf: false });
    }
  }
}
